module.exports = __webpack_public_path__ + "static/media/admin1.fe4b4a91.svg";